import { type ComponentProps, useEffect } from 'react';
import { Toaster as SonnerToaster, toast } from 'sonner';

type ToasterProps = ComponentProps<typeof SonnerToaster>;

const Toaster = (props: ToasterProps) => {
  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (!(e.target instanceof Element)) {
        return;
      }
      const toastEl = e.target.closest<HTMLElement>('[data-sonner-toast]');
      if (toastEl) {
        toastEl.style.transition = 'opacity 200ms ease, transform 200ms ease';
        toastEl.style.opacity = '0';
        toastEl.style.transform = 'translateY(20px)';
        const toastId = toastEl.dataset.id;
        setTimeout(() => toast.dismiss(toastId), 200);
      }
    };
    document.addEventListener('mousedown', handler, true);
    return () => document.removeEventListener('mousedown', handler, true);
  }, []);

  return <SonnerToaster {...props} />;
};

export { Toaster };
